module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Save-b403ca937f10c3f4c9dae3b17defc570.svg";